import { Fragment, type ReactNode } from 'react';
import { Box } from '@mui/material';

export type QuoteSegment = { text: string; unverified: boolean };

export function markUnverified(text: string, spans: readonly string[]): QuoteSegment[] {
  const ranges: [number, number][] = [];
  for (const span of new Set(spans)) {
    if (!span) continue;
    for (let at = text.indexOf(span); at !== -1; at = text.indexOf(span, at + span.length)) ranges.push([at, at + span.length]);
  }
  ranges.sort((a, b) => a[0] - b[0]);
  const segments: QuoteSegment[] = [];
  let cursor = 0;
  for (const [start, end] of ranges) {
    if (start < cursor) continue;
    if (start > cursor) segments.push({ text: text.slice(cursor, start), unverified: false });
    segments.push({ text: text.slice(start, end), unverified: true });
    cursor = end;
  }
  if (cursor < text.length) segments.push({ text: text.slice(cursor), unverified: false });
  return segments;
}

const asText = (text: string): ReactNode => text;

export function UnverifiedQuoteText({ text, spans, renderPlain = asText }: { text: string; spans: readonly string[]; renderPlain?: (text: string) => ReactNode }) {
  return (
    <>
      {markUnverified(text, spans).map((s, i) =>
        s.unverified ? (
          <Box key={i} component="span" data-testid="unverified-quote" title="Not found in this household's record" sx={{ bgcolor: '#fff4dc', borderBottom: '1px dashed #b8860b' }}>
            {s.text}
            <Box component="span" sx={{ ml: 0.5, px: 0.5, borderRadius: 0.5, fontSize: 11, fontWeight: 600, color: '#7a5a00', bgcolor: '#fde9b5', whiteSpace: 'nowrap' }}>
              unverified
            </Box>
          </Box>
        ) : (
          <Fragment key={i}>{renderPlain(s.text)}</Fragment>
        ),
      )}
    </>
  );
}
